import React, { useState, useContext, useLayoutEffect } from 'react';
import { IoIosAddCircle } from "react-icons/io";
import UsersService from '../../../services/users.service';
import AirlinesService from '../../../services/airlines.servicse';
import AdministratorRow from './AdministratorRow'
import AuthContext from 'store/AuthContext';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from 'components/common/skeleton/AppSkeleton';
import { AppTableNoData } from 'components/common/AppTableUtils';
import ToastContext from 'store/ToastContext';
import ModalContext from 'store/ModalContext';
import AdministratorNewEditForm from './AdministratorNewEditForm';


export default function AdministratorManagement(props) {
    const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const { openModal, modalDispatch } = useContext(ModalContext);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
   // const [airlinesOptions, setAirlinesOptions] = useState([]);
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });
   
    const fetchAirlines = () => {
        modalDispatch({type:"airlines", payload: {isLoading: true, airlines: []}});
        AirlinesService.getAirlinesOptions()
        .then(data => {
           // setAirlinesOptions(data);
            modalDispatch({type:"airlines", payload: {isLoading: false, airlines: data}});
        })
        .catch(err => {
           // setAirlinesOptions([]);
            modalDispatch({type:"airlines", payload: {isLoading: false, airlines: []}});
        });
    }

    useLayoutEffect(() => {
        if(!userInfo.isOwner){
            props.history.push({
                pathname: `/`
            });
            return;
        }
        fetchAdmins();
        fetchAirlines();
    }, [userInfo.isOwner,props.history])
    
    const fetchAdmins = ()=> {
        setIsLoading(true);
        UsersService.getAdmins().then(data => {
            setData(data);
            setIsLoading(false);
        }).catch(err=>{
            setData([]);
            setIsLoading(false);
        })

    }

  

    const onRowUpdateSubmitted = async (values, action) => {
        setIsLoading(true);
        if (action === "delete") {
            const del = await UsersService.deleteUser(values);
            if (del.code === 0) {
                openToast("User deleted", "success");
                fetchAdmins();
            } else {
                openToast(del.description, "error", {duration:8000});
                setIsLoading(false);
            }
        } else if (action === "refresh"){
            fetchAdmins();
        } else {
            setIsLoading(false);
        }

    }

    const addAdmin = () => {
        openModal(
          <AdministratorNewEditForm />,
          "Administrator Definition",
          { showActions: false }
        )
          .then((data) => {
            fetchAdmins();
          })
          .catch((err)=>{});
    };


    const redirectToDocTypes = () => {
        props.history.push({
            pathname: `/DocTypes`
        })
    }
    const redirectToConstants = () => {
        props.history.push({
            pathname: `/Constants`
        })
    }

    const redirectToActivityLog = () => {
        props.history.push({
            pathname: `/ActivityLogForAdmin/${userInfo.email}`
        })
    }
    return (
        <>
            <div className="container-fluid">
                <div className="form-group row">
                    <h2>Airline Administrators Management</h2>
                </div>
                <div className="adminBtns">
                    <AppButton action={addAdmin} label="Add administrator" classes="margingRight" icon={<IoIosAddCircle />}></AppButton>
                    <AppButton action={redirectToConstants} label="Constants" classes="margingRight"></AppButton>
                    <AppButton action={redirectToDocTypes} label="Doc Types" classes="margingRight" ></AppButton>
                    <AppButton action={redirectToActivityLog} label="Activity Log" ></AppButton>                    
                </div>
                {isLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={8} variant="table" size="28px"/> : (
                    <div className="row">
                        <div className="table responsive striped">
                            <div className="row" style={{ background: "whitesmoke", padding: "15px" }}>
                                <div className="col-2" >Airline</div>
                                <div className="col-1" >AirlineCode</div>
                                <div className="col-1" >LastName</div>
                                <div className="col-1" >FirstName </div>
                                <div className="col-3" >UserName</div>
                                <div className="col-2" >PhoneNumber</div>
                                <div className="col-1" >FaxNumber</div>
                                <div className="col-1" >Actions</div>
                            </div>
                            {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                                return (
                                    <AdministratorRow item={item} key={i} onSubmitted={onRowUpdateSubmitted} props={props} />
                                )
                            })}
                            </div>
                        {!data.length ? <AppTableNoData /> :
                                <AppPagination
                                    pageSize={paginationObject.pageSize}
                                    totalRecords={data.length}
                                    currentPage={paginationObject.currPage}
                                    endIndex={paginationObject.endIndex}
                                    startIndex={paginationObject.startIndex}
                                    setPaginationObject={(ele) => {
                                        setPaginationObject((data) => {
                                            return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                        })
                                    }}
                                ></AppPagination>
                            }
                    </div>)
                }
            </div>
        </>
    )
}